import React from "react";
import { useColorModeValue } from "@chakra-ui/react";

import Card from "../Card/Card";
import CardBody from "../Card/CardBody";
import { NotesListEditor } from "./NotesListEditor";
import { useExecutingAccountNotesList } from "./useExecutingAccountNotesList";
import type { BrokerAccountRef } from "@/utils/brokerAccountRef";
import { reportDetailSectionCardProps } from "../../views/Dashboard/Reports/components/ReportsCardChrome";

export function WorkspaceAccountNotesSection(props: {
  account: BrokerAccountRef;
  borderColor?: string;
  subtleText?: string;
  textColor?: string;
}): React.ReactElement {
  const defaultBorder = useColorModeValue("gray.200", "var(--border)");
  const defaultSubtle = useColorModeValue("gray.500", "var(--sidebar-muted-foreground)");
  const defaultText = useColorModeValue("gray.700", "var(--sidebar-foreground)");

  const borderColor = props.borderColor ?? defaultBorder;
  const subtleText = props.subtleText ?? defaultSubtle;
  const textColor = props.textColor ?? defaultText;

  const notes = useExecutingAccountNotesList(props.account);

  return (
    <Card {...reportDetailSectionCardProps} borderRadius="12px" mt={0} w="100%">
      <CardBody>
        <NotesListEditor
          composerVariant="shadcn"
          composerLabel="Account notes"
          notes={notes.notes}
          loading={notes.loading}
          error={notes.error}
          draft={notes.draft}
          onDraftChange={notes.setDraft}
          editingId={notes.editingId}
          editingBody={notes.editingBody}
          onEditingBodyChange={notes.setEditingBody}
          saving={notes.saving}
          canSubmit={notes.canSubmit}
          onCreate={() => void notes.onCreate()}
          onStartEdit={notes.startEdit}
          onCancelEdit={notes.cancelEdit}
          onSaveEdit={() => void notes.saveEdit()}
          onDelete={(id) => void notes.onDelete(id)}
          borderColor={borderColor}
          subtleText={subtleText}
          textColor={textColor}
        />
      </CardBody>
    </Card>
  );
}
